import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./navbar.css";
import ModalForm from "./ModalForm";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isNavOpen, setIsNavOpen] = useState(false);

    const toggleModal = () => {
        setIsOpen(!isOpen);
    };

    const toggleNav = () => {
        setIsNavOpen(!isNavOpen);
    };

    return (
        <>
            <nav className="navbar navbar-expand-lg p-3 navbar-dark">
                <div className="container-fluid">
                    <img src="./logo2.png" alt="Logo" width="200" height="50" />

                    {/* Custom Toggler button for mobile */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={toggleNav}
                        style={{backgroundColor:"rgba(0, 0, 0, 0.47)", color:"#fff"}}
                    >
                        {isNavOpen ? (
                            <span style={{ fontSize: "30px", color: "#fff" }}>&times;</span> // Close (×) icon
                        ) : (
                            <span className="navbar-toggler-icon"></span> // Default Bootstrap toggler
                        )}
                    </button>


                    <div className={`collapse navbar-collapse ${isNavOpen ? "show" : ""}`} id="navbarSupportedContent">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <NavLink className="nav-link" exact to="/" activeClassName="active" style={{ color: "#000" }}>
                                    Home
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/about" activeClassName="active" style={{ color: "#000" }}>
                                    About
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/contact" activeClassName="active" style={{ color: "#000" }}>
                                    Contact
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/gallery" activeClassName="active" style={{ color: "#000" }}>
                                    Gallery
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <button className="btn" style={{ backgroundColor: "rgb(216, 37, 2)", fontWeight: "bold", color: "#fff" }} onClick={toggleModal}>
                                    Enquiry Now
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <div className="d-flex justify-content-center align-items-center" style={{ backgroundColor: "#1e1e1e" }}>
                <a href="#" className="fw-bold p-2 dom" style={{ fontSize: "15px" }}>
                    www.<span style={{ color: "#ff3e6c" }}>balloon</span>
                    decoration<span style={{ color: "#ff3e6c" }}>near</span>me.
                    <span style={{ color: "#ff3e6c" }}>com</span>
                </a>
            </div>

            {/* Modal Component */}
            <ModalForm isOpen={isOpen} toggleModal={toggleModal} />

            <div className="floating-icons">
                {/* WhatsApp Icon */}
                <a href="https://wa.me/+919820473034" target="_blank" rel="noopener noreferrer" className="whatsapp-icon">
                    <i className="fa-brands fa-whatsapp" style={{ color: "#fff" }}></i>
                </a>
                {/* Call Icon */}
                <a href="tel:+919820473034" className="call-icon">
                    <i className="fa-solid fa-phone" style={{ color: "#fff" }}></i>
                </a>
            </div>
        </>
    );
};

export default Navbar;
